import Component from 'routes/Statics/ContactUs'

const defaultProps = {}
const propTypes = {}

export const Page = props => <Component {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
